import { Charges } from '@models';
import { Component } from '@angular/core';
import { EMDASH } from '@products/utils/constants/product.constants';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ProductData } from '@types';
import { TranslateService } from '@shared/translate/translate.service';

@Component({
  selector: 'ft-expense-ratio-cell-renderer',
  templateUrl: './expense-ratio-cell-renderer.component.html',
  styleUrls: ['./expense-ratio-cell-renderer.component.scss'],
})
export class ExpenseRatioCellRendererComponent {
  charges: Charges;
  tooltipContent: string;
  showTooltipAtTop: boolean;

  constructor(private translateService: TranslateService) {}

  agInit(params: ICellRendererParams) {
    const product: ProductData = params.data;
    this.charges = product?.shareClass?.charges;

    // NGC-10974: To make tooltip appear at top for the last two elements.
    const lastRowIndex =
      params.context.currentPage * params.context.pageSize - 1;

    if (
      lastRowIndex === params.rowIndex ||
      lastRowIndex - 1 === params.rowIndex ||
      params?.context?.filteredRows?.length === params.rowIndex ||
      params?.context?.filteredRows?.length - 1 === params.rowIndex
    ) {
      this.showTooltipAtTop = true;
    } else {
      this.showTooltipAtTop = false;
    }

    if (this.charges?.waiverEndDate && this.charges.waiverEndDate !== EMDASH) {
      const title = this.translateService.instant(
        'products.exp-ratio-tootltip-title'
      );
      const waiverTypeText = this.translateService.instant(
        'products.exp-ratio-tootltip-waiver-type'
      );
      const waiverEndDateText = this.translateService.instant(
        'products.exp-ratio-tootltip-waiver-end-date'
      );
      const waiverEndDate = this.charges?.waiverEndDate
        ? this.charges.waiverEndDate
        : EMDASH;
      this.tooltipContent = `<b>${title}</b><br><br>${waiverTypeText}:<b> ${this.charges.waiverType}</b><br>${waiverEndDateText}:<b> ${waiverEndDate}</b>`;
    }
  }
}
